import { cn } from "../../helpers"
import { paragraph, title } from "../typography"

const dialogOverlayStyle = (className?: string) =>
  cn(
    "fixed inset-0 z-50 bg-neutral-600/60",
    "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
    className,
  )

const dialogContentStyle = (className?: string) =>
  cn(
    "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-8 rounded-[2rem] border bg-white p-6 shadow-lg duration-200",
    "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]",
    className,
  )

const dialogCloseStyle = cn("ml-auto")

const dialogFooterStyle = (className?: string) => cn("flex w-full flex-col gap-3", className)

const dialogIconStyle = (className?: string) => cn("flex w-full justify-center", className)

const dialogTitleStyle = (className?: string) =>
  cn(title({ size: "lg", className: "text-center" }), className)

const dialogDescriptionStyle = (className?: string) =>
  cn(paragraph({ size: "sm", className: "text-center text-neutral-700" }), className)

const dialogTextContainer = cn("flex flex-col gap-2")

export {
  dialogOverlayStyle,
  dialogContentStyle,
  dialogCloseStyle,
  dialogFooterStyle,
  dialogIconStyle,
  dialogTitleStyle,
  dialogDescriptionStyle,
  dialogTextContainer,
}
